import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import React, { useContext } from 'react';
import DailyEngagedUsersContext from '../../../contexts/DailyEngagedUsersContext';
import { CompiledDailyEngagedUsersOverspentMessagesPaperContent } from '../styles';

const CompiledDailyEngagedUserOverspentContentComponent: React.FC = () => {
  const { content, compiledDailyEngagedUserDataState } = useContext(DailyEngagedUsersContext);

  const exceededPlan = (toLocaleString: boolean) => {
    if (compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth) {
      return toLocaleString
        ? compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.exceededPlan.toLocaleString(
          content.locale,
        )
        : compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.exceededPlan;
    } else {
      return '--';
    }
  };

  return (
    <CompiledDailyEngagedUsersOverspentMessagesPaperContent>
      <BdsTypo tag="h4" variant="fs-16" bold="bold" margin={false}>
        {content.compiledDailyEngagedUserInformation.overspentMessages}
      </BdsTypo>
      <BdsTypo tag="h4" variant="fs-32" bold="bold" margin={false} data-exceededPlan={exceededPlan(false)}>
        {exceededPlan(true)}
      </BdsTypo>
    </CompiledDailyEngagedUsersOverspentMessagesPaperContent>
  );
};

export default CompiledDailyEngagedUserOverspentContentComponent;
